import { render, staticRenderFns } from "./clientTotalSpent.vue?vue&type=template&id=005fab2e&scoped=true&"
import script from "./clientTotalSpent.vue?vue&type=script&lang=js&"
export * from "./clientTotalSpent.vue?vue&type=script&lang=js&"
import style0 from "./clientTotalSpent.vue?vue&type=style&index=0&id=005fab2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005fab2e",
  null
  
)

export default component.exports